export interface Testimonial {
  text: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    text: 'J’avais déjà acheté des ampoules connectées, deux capteurs et une prise, mais chaque appareil avait son application et rien ne communiquait. Le module de conception m’a fait tout reprendre à zéro, zone par zone. Aujourd’hui mon appartement fonctionne avec une seule interface et des scénarios matin et nuit qui se déclenchent tout seuls.',
    author: 'Julien M.',
    role: 'Technicien, 38 ans',
    location: 'Lyon, France',
  },
  {
    text: 'Je voulais équiper la maison sans dépendre d’un installateur pour chaque détail. Ce qui m’a le plus servi, c’est le guide de compatibilité : j’ai enfin compris la différence entre Zigbee, Thread et Matter avant d’acheter. J’ai évité au moins trois mauvais achats et une passerelle inutile.',
    author: 'Christophe D.',
    role: 'Propriétaire, 45 ans',
    location: 'Nantes, France',
  },
  {
    text: 'Je partais vraiment de zéro et je craignais que ce soit trop technique. La progression est très bien pensée : on comprend d’abord, on planifie ensuite, on installe après. J’ai automatisé le chauffage et les volets de tout l’étage, et ma facture d’énergie a baissé cet hiver.',
    author: 'Sandrine L.',
    role: 'Assistante de direction, 41 ans',
    location: 'Bordeaux, France',
  },
  {
    text: 'Le Troubleshooting Bible a changé ma façon de travailler. Avant, quand un capteur passait hors ligne, je testais au hasard pendant des heures. Maintenant je suis la procédure de diagnostic et je trouve la cause en quelques minutes. C’est la partie que je consulte le plus souvent.',
    author: 'Karim B.',
    role: 'Électricien indépendant, 34 ans',
    location: 'Toulouse, France',
  },
  {
    text: 'Je suis à la retraite et je cherchais un projet sérieux à mener chez moi. J’ai suivi les six modules dans l’ordre, avec les checklists imprimées. La maison est entièrement équipée, documentée, et mon fils utilise maintenant mes fiches pour faire la même chose chez lui.',
    author: 'Michel R.',
    role: 'Retraité, 62 ans',
    location: 'Strasbourg, France',
  },
]
